import { render, staticRenderFns } from "./GeneralCell.vue?vue&type=template&id=f57504dc&"
import script from "./GeneralCell.vue?vue&type=script&lang=js&"
export * from "./GeneralCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports